import React, { Component } from 'react'
import botImg from '../assets/images/ai.png'

class Custom extends Component {
  constructor(props) {
    super(props)

    this.state = {
      type: '',
      gender: '',
      loaded: 0,
    }
    this.customMesage = this.customMesage.bind(this)
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { steps, type } = nextProps
    const { name, gender } = steps
    const full = ((name || '').value || '').split(' ')
    const first = full[0] || ''
    // const second = full[1] || ''
    if (prevState.loaded === 0) {
      return {
        name: first,
        type: type,
        gender: (gender || '').value || '',
        loaded: 1,
      }
    }
    return null
  }
  customMesage = (e, txt) => {
    var messGen = ''
    if (this.state.gender === 'masculino') {
      messGen = txt.genAa
    } else if (this.state.gender === 'femenino') {
      messGen = txt.genBa
    } else {
      messGen = txt.genCa
    }
    switch (e) {
      case 'gender':
        return `${txt.genHappy1} ${messGen} ${txt.genHappy2}`
      case 'name':
        return `${txt.nameAns1}${this.state.name}${txt.nameAns2}`
      default:
        return `${txt.bye1}${this.state.name}${txt.bye2}`
    }
  }
  render() {
    const { type, txt } = this.props

    const message = this.customMesage(type, txt)
    return (
      <div className='rsc-ts rsc-ts-bot customBub'>
        <div className='rsc-ts-image-container csBotCnt'>
          <img
            className='rsc-ts-image customBotBub'
            src={botImg}
            alt='avatar'
          />
        </div>
        <div
          className='sc-gKclnd rsc-ts-bubble textBub'
          style={{
            width: '80%',
            maxWidth: ' 80%',
            color: 'rgb(255, 255, 255)',
            background:
              'linear-gradient(to right, rgb(0, 77, 205) 5%, rgba(0, 77, 205, 0.6))',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {message}
        </div>
      </div>
    )
  }
}
export default Custom
